import { createIcon } from '../shared'

const RepostIcon = createIcon(
  ({ color }) => (
    <path
      d="M4.49841 3.87988L8.93041 8.01988L7.56641 9.47988L5.49841 7.54988V15.9999C5.49841 17.0999 6.39441 17.9999 7.49841 17.9999H12.9984V19.9999H7.49841C5.28941 19.9999 3.49841 18.2099 3.49841 15.9999V7.54988L1.43041 9.47988L0.0664062 8.01988L4.49841 3.87988ZM16.4984 5.99988H10.9984V3.99988H16.4984C18.7074 3.99988 20.4984 5.78988 20.4984 7.99988V16.4499L22.5664 14.5199L23.9304 15.9799L19.4984 20.1199L15.0664 15.9799L16.4304 14.5199L18.4984 16.4499V7.99988C18.4984 6.89988 17.6024 5.99988 16.4984 5.99988Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'TwitterRepostIcon',
)

export { RepostIcon }
